export const statusOptions = [
    {
        label: '现场处理',
        value: "现场处理"
    },
    {
        label: '分析中',
        value: "分析中"
    },
    {
        label: '进行中',
        value: "进行中"
    },
    {
        label: '已完成',
        value: "已完成"
    },
];